const defaultState = () => {
   return {
      policyTemplateStatusList: null,
      policyGroupList: null,
      standardsPayload: null, // Caches standards, controls, and evidence requirements
      promises: {
         statuses: null,
         groups: null,
         standards: null
      }
   }
}

const state = () => (defaultState());

const actions = {
   resetDropdownState({ commit }) {
      commit("resetDropdownState");
   },

   async fetchStatuses({ state, commit }, axios) {
      if (state.policyTemplateStatusList) return state.policyTemplateStatusList;
      
      if (!state.promises.statuses) {
         // Use the passed axios instance
         state.promises.statuses = axios.get("/policy-template/statuses").then(res => {
            const data = res.data.statuses || [];
            commit('setPolicyTemplateStatusList', data);
            return data;
         }).finally(() => {
            state.promises.statuses = null; 
         });
      }
      return await state.promises.statuses;
   },

   async fetchGroups({ state, commit }, axios) {
      if (state.policyGroupList) return state.policyGroupList;
      
      if (!state.promises.groups) {
         state.promises.groups = axios.get("/policy-template/groups").then(res => {
            const data = res.data.groups || [];
            commit('setPolicyGroupList', data);
            return data;
         }).finally(() => {
            state.promises.groups = null;
         });
      }
      return await state.promises.groups;
   },

   async fetchStandards({ state, commit }, axios) {
      if (state.standardsPayload) return state.standardsPayload;
      
      if (!state.promises.standards) {
         state.promises.standards = axios.get("/policy-template/standards").then(res => {
            const payload = res.data.standards || {};
            
            const filteredStandards = (payload.standards || []).filter(
               standard => standard.name !== 'ISO27001'
            );
            
            const cachedData = {
               standards: filteredStandards,
               controls: payload.controls || [],
               evidence_requirements: payload.evidence_requirements || []
            };
            
            commit('setStandardsPayload', cachedData);
            return cachedData;
         }).finally(() => {
            state.promises.standards = null;
         });
      }
      return await state.promises.standards;
   }
};

const mutations = {
   resetDropdownState(state) {
      Object.assign(state, defaultState());
   },
   setPolicyTemplateStatusList(state, list) {
      state.policyTemplateStatusList = list;
   },
   setPolicyGroupList(state, list) {
      state.policyGroupList = list;
   },
   setStandardsPayload(state, payload) {
      state.standardsPayload = payload;
   }
};

export default {
   name: "policyTemplate",
   namespaced: true,
   state,
   actions,
   mutations,
};